'use strict';

import React from 'react';
import Group from '../organisms/Group';
import SidebarBody from '../organisms/SidebarBody';
import createStoreMixin from '../mixins/createStoreMixin';
import StampLikesStore from '../stores/StampLikesStore';
import StampActionCreators from '../actions/StampActionCreators';
import PureRenderMixin from '../mixins/PureRenderMixin';
import UserStore from '../stores/UserStore';
import { PropTypes } from 'react';
import StampStore from '../stores/StampStore';
import getStampSegment from '../utils/getStampSegment';

var StampLikes = React.createClass({
  mixins: [createStoreMixin(StampLikesStore, UserStore, StampStore), PureRenderMixin],

  propTypes: {
    stampId: PropTypes.number.isRequired
  },

  getStateFromStores() {
    const { stampId } = this.props;
    var stampLikes = StampLikesStore.getStampLikes(stampId);

    return {
      stampLikes: stampLikes,
      stamp: StampStore.get(stampId)
    };
  },

  componentDidMount() {
    const stampSegment = getStampSegment(this.state.stamp);
    StampActionCreators.requestStampLikePage(stampSegment, true);
  },

  render: function () {
    var { stampId } = this.props;

    return (
      <SidebarBody title='Liked By'>
        <Group type='users'
               items={this.state.stampLikes}
               itemProps={{
                 vertical: true,
                 size: 'small',
                 imageSize: 'large',
                 showLocation: true,
                 showAbout: true,
                 context: 'StampLikes',
                 showFollow: true
               }}
               context='sidebar'
               mode='grid'
               columns={2}
               isExpectingPage={StampLikesStore.isExpectingPage(stampId)}
               isLastPage={StampLikesStore.isLastPage(stampId)}
               isInvalidated={StampLikesStore.isInvalidated(stampId)}
               loadNextPage={this.requestNextPage} />
      </SidebarBody>
    );
  },

  requestNextPage() {
    const stampSegment = getStampSegment(this.state.stamp);
    StampActionCreators.requestStampLikePage(stampSegment);
  }
});

module.exports = StampLikes;



/** WEBPACK FOOTER **
 ** ./sidebar/StampLikes.jsx
 **/